import axios from 'axios'
import AwsConfig from '../../Config/AwsConfig'
import MovieImagePresignedUrl from '../../Services/Queries/Movieimagepresignedurl'
import { v4 as uuidv4 } from 'uuid'

const sendtoEditdata = async (data, sendEditdata, sendBooleanValueChangeofEdit) => {
  const editDataTemp = { ...data.editData }
  // console.log(data.field, 'data.field')
  if (data.field === 'cast') {
    editDataTemp.Moviecast = [
      ...editDataTemp.Moviecast,
      ...data.objectNotPresent.MoviecastnotPresent,
    ]
    const movieCastte = data.objectNotPresent.MoviecastnotPresent.map(e =>
      e.name_Te ? e.name_Te : '',
    )
    editDataTemp.cast = data.objectNotPresent.MoviecastnotPresent
    editDataTemp.Moviecastte = [...editDataTemp.Moviecastte, ...movieCastte]
    sendBooleanValueChangeofEdit('cast', true)
    sendEditdata(editDataTemp)
  } else if (data.field === 'MovieCimematographer') {
    editDataTemp.MovieCimematographer = [
      ...editDataTemp.MovieCimematographer,
      ...data.objectNotPresent.movieCinematonotPresent,
    ]
    const cinematographerTelugu = data.objectNotPresent.movieCinematonotPresent.map(e =>
      e.name_Te ? e.name_Te : '',
    )

    editDataTemp.MovieCimematographerTelugu = [
      ...editDataTemp.MovieCimematographerTelugu,
      ...cinematographerTelugu,
    ]
    sendBooleanValueChangeofEdit('crew', true)
    sendEditdata(editDataTemp)
  } else if (data.field === 'Moviewritter') {
    editDataTemp.Moviewritter = [
      ...editDataTemp.Moviewritter,
      ...data.objectNotPresent.movieWriternotPresent,
    ]
    const movieWritterTe = data.objectNotPresent.movieWriternotPresent.map(e =>
      e.name_Te ? e.name_Te : '',
    )
    editDataTemp.Moviewritterte = [...editDataTemp.Moviewritterte, ...movieWritterTe]
    sendBooleanValueChangeofEdit('crew', true)
    sendEditdata(editDataTemp)
  } else if (data.field === 'Moviemusicby') {
    editDataTemp.Moviemusicby = [
      ...editDataTemp.Moviemusicby,
      ...data.objectNotPresent.movieMusicnotPresent,
    ]
    const musicbyTe = data.objectNotPresent.movieMusicnotPresent.map(e =>
      e.name_Te ? e.name_Te : '',
    )
    editDataTemp.Moviemusicbyte = [...editDataTemp.Moviemusicbyte, ...musicbyTe]
    sendBooleanValueChangeofEdit('crew', true)
    sendEditdata(editDataTemp)
  } else if (data.field === 'MovieEditor') {
    editDataTemp.MovieEditor = [
      ...editDataTemp.MovieEditor,
      ...data.objectNotPresent.movieEditornotPresent,
    ]
    const movieEditorte = data.objectNotPresent.movieEditornotPresent.map(e =>
      e.name_Te ? e.name_Te : '',
    )
    editDataTemp.MovieEditorte = [...editDataTemp.MovieEditorte, ...movieEditorte]
    sendBooleanValueChangeofEdit('crew', true)
    sendEditdata(editDataTemp)
  } else if (data.field === 'Moviedirector') {
    editDataTemp.Moviedirector = [
      ...editDataTemp.Moviedirector,
      ...data.objectNotPresent.movieDirectornotPresent,
    ]
    const directorTelugu = data.objectNotPresent.movieDirectornotPresent.map(e =>
      e.name_Te ? e.name_Te : '',
    )
    editDataTemp.Moviedirectorte = [...editDataTemp.Moviedirectorte, ...directorTelugu]
    sendBooleanValueChangeofEdit('crew', true)
    sendEditdata(editDataTemp)
  } else if (data.field === 'MovieProducer') {
    editDataTemp.MovieProducer = [
      ...editDataTemp.MovieProducer,
      ...data.objectNotPresent.movieProducernotPresent,
    ]
    const producerTelugu = data.objectNotPresent.movieProducernotPresent.map(e =>
      e.name_Te ? e.name_Te : '',
    )
    editDataTemp.MovieProducerTelugu = [...editDataTemp.MovieProducerTelugu, ...producerTelugu]
    sendBooleanValueChangeofEdit('crew', true)
    sendEditdata(editDataTemp)
  } else if (data.field === 'MovieScreenPlay') {
    editDataTemp.MovieScreenPlay = [
      ...editDataTemp.MovieScreenPlay,
      ...data.objectNotPresent.MovieScreenPlaynotPresent,
    ]
    const screenolayTelugu = data.objectNotPresent.MovieScreenPlaynotPresent.map(e =>
      e.name_Te ? e.name_Te : '',
    )
    editDataTemp.MovieScreenPlayTelugu = [
      ...editDataTemp.MovieScreenPlayTelugu,
      ...screenolayTelugu,
    ]
    sendBooleanValueChangeofEdit('crew', true)
    sendEditdata(editDataTemp)
    //
  } else if (data.field === 'MovieDialoge') {
    editDataTemp.MovieDialoge = [
      ...editDataTemp.MovieDialoge,
      ...data.objectNotPresent.MovieDialogeWritternotPresent,
    ]
    const movieDialogenotPresent = data.objectNotPresent.MovieDialogeWritternotPresent.map(e =>
      e.name_Te ? e.name_Te : '',
    )
    editDataTemp.MovieDialogete = [...editDataTemp.MovieDialogete, ...movieDialogenotPresent]
    sendBooleanValueChangeofEdit('crew', true)
    sendEditdata(editDataTemp)
  } else if (data.field === 'story') {
    editDataTemp.story = [...editDataTemp.story, ...data.objectNotPresent.MovieStorynotPresent]
    const StoryTelugu = data.objectNotPresent.MovieStorynotPresent.map(e =>
      e.name_Te ? e.name_Te : '',
    )
    editDataTemp.storyte = [...editDataTemp.storyte, ...StoryTelugu]
    sendBooleanValueChangeofEdit('crew', true)
    sendEditdata(editDataTemp)
  } else if (data.field === 'releasedate') {
    editDataTemp.releaseDate = data.inputData.releaseDate
    sendBooleanValueChangeofEdit('releasedate', true)
    sendEditdata(editDataTemp)
  } else if (data.field === 'MovieProductionCompany') {
    editDataTemp[data.field] = [...editDataTemp[data.field], ...data.inputData[data.field]]
    editDataTemp.MovieProductionCompanyTelugu = [
      ...editDataTemp.MovieProductionCompanyTelugu,
      ...data.inputData.MovieProductionCompanyTelugu,
    ]
    sendBooleanValueChangeofEdit('ProductionCompany_En', true)
    sendEditdata(editDataTemp)
  } else if (data.field === 'poster') {
    const posterFile = await getImageFromURL(data.inputData.poster)
    // console.log('posterFile', posterFile)
    const dataTemp = { ...data, posterFile }
    uploadSelectedImage(dataTemp, sendEditdata, sendBooleanValueChangeofEdit)
    // editDataTemp[data.field] = data.inputData[data.field]

    // sendBooleanValueChangeofEdit('poster', true)
    // sendEditdata(editDataTemp)
  } else if (data.field === 'MovieDistibutor') {
    editDataTemp[data.field] = [...editDataTemp[data.field], ...data.inputData[data.field]]
    editDataTemp.MovieDistibutorTelugu = [
      ...editDataTemp.MovieDistibutorTelugu,
      ...data.inputData.MovieDistibutorTelugu,
    ]
    sendEditdata(editDataTemp)
  } else if (data.field === 'runtime') {
    editDataTemp.runTime = data.inputData.runTime
    sendEditdata(editDataTemp)
  } else if (data.field === 'wikipedia') {
    editDataTemp.wikilink = data.inputData.wikilink
    sendEditdata(editDataTemp)
  } else {
    editDataTemp[data.field] = data.inputData[data.field]
    // console.log(' in send to EditData')
    sendEditdata(editDataTemp)
  }
}

function convertBlobToFile(blob, fileName) {
  blob.lastModifiedDate = new Date()
  blob.name = fileName
  return blob
}

async function getImageFromURL(imageUrl) {
  const response = await fetch(imageUrl, {
    method: 'GET',
    headers: {},
  })

  const arrayBuffer = await response.arrayBuffer()

  // console.log(arrayBuffer, 'arrayBuffer')

  const blob = new Blob([arrayBuffer, { type: 'image/png' }])

  const file = convertBlobToFile(blob, 'image.png')

  return file

  // const url = URL.createObjectURL(blob);
}

const uploadSelectedImage = async (data, sendEditdata, sendBooleanValueChangeofEdit) => {
  const editDataTemp = { ...data.editData }
  const randomId = await uuidv4()
  const moviePath = AwsConfig.moviePathUrl
  const key = moviePath + randomId + '.jpeg'
  const params = {
    key,
    mimeType: 'image/jpeg',
  }
  // console.log(params, 'params')
  const preSignedURLObject = await MovieImagePresignedUrl(params)
  // console.log(preSignedURLObject, 'urlobject=++++')
  const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
  // console.log(signedURLObject, 'signedurlobject')
  const signedURL = signedURLObject.data.url
  // console.log(signedURL, 'signedurl')
  try {
    const formData = new FormData()
    // console.log(formData, 'formData== in story')
    Object.keys(signedURLObject.data.fields).forEach(key => {
      formData.append(key, signedURLObject.data.fields[key])
    })
    // Actual file has to be appended last.
    formData.append('file', data.posterFile)

    // console.log(signedURL, 'signedURL==  in upload 1111')
    // console.log(formData, 'form, in upload 1111')
    // console.log(data.inputData[data.field], 'form, selectedImage, in upload 1111')

    // const response =
    await axios({
      method: 'post',
      url: signedURL,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    // console.log(response, 'response=== in comp')
    const cdnurl = AwsConfig.movieCdnUrl
    // console.log(cdnurl, 'this is cdnurlllll')
    const posterUrl = cdnurl + key
    // console.log(posterUrl, 'this is uriiiiiiiiiii')
    // props.sendPosterUrl('poster', posterUrl)
    editDataTemp[data.field] = posterUrl
    sendBooleanValueChangeofEdit('poster', true)
    sendEditdata(editDataTemp)
  } catch (err) {
    return err
    // console.warn(err, 'err')
  }
}

export default sendtoEditdata
